import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import useLocale from 'containers/SettingsProvider/useLocale';
import { useCurrentUser } from 'containers/User';
import { dateFormat } from 'utils/datetime';
import { useRequest } from 'utils/request';

function usePromotion() {
  const date = dateFormat(new Date());
  const user = useCurrentUser();
  const locale = useLocale();
  const skipPromo = Cookies.get('skipPromo') || user.loading;
  const [promotions] = useRequest({
    url: !skipPromo && `/promotions?date=${date}&hl=${locale}&v=2`,
    user,
  });
  const [promotion, setPromotion] = useState(null);
  useEffect(
    () => {
      if (promotions && !promotions.loading && !promotions.error) {
        promotions.some(prom => {
          if (Cookies.get(prom.cookie)) {
            return false;
          }
          setPromotion(prom);
          return true;
        });
      }
    },
    [promotions],
  );
  if (!promotion) {
    return [];
  }
  function setSeen() {
    Cookies.set(promotion.cookie, true, {
      expires: promotion.ndays,
      path: '/',
      sameSite: 'strict',
    });
    Cookies.set('skipPromo', true, {
      path: '/',
      sameSite: 'strict',
    });
    setPromotion(null);
  }
  // TODO confirm/fix issue with Google Consent
  return [null, setSeen];
  // return [promotion, setSeen];
}

export default usePromotion;
